
import MainStore from "../store/MainStore";

class CUFormService {

    getUserInfo(){
        /*
        let userInfo = {
            name: (MainStore.getState().MeReducer.name)?MainStore.getState().MeReducer.name:null,
            email: (MainStore.getState().MeReducer.email)?MainStore.getState().MeReducer.email:null,
            address: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity .address)?MainStore.getState().MeReducer.entity.address:null,
            phone: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.phone)?MainStore.getState().MeReducer.entity.phone:null,
            siren: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.siren)?MainStore.getState().MeReducer.entity.siren:null,
            cp:  (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.cp)?MainStore.getState().MeReducer.entity.cp:null,
            city:  (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.city)?MainStore.getState().MeReducer.entity.city:null,
        }

         */
        return MainStore.getState().MeReducer.entity
    }

    getEntityInfo(){
        //console.log(MainStore.getState().MeReducer.entity)
        return MainStore.getState().MeReducer.entity
    }

    updateUserInfo(demInfo){
        MainStore.dispatch({type: 'UPDATE_DEMANDEUR_INFO', data:{demInfo: demInfo}})
    }

    getData(sectionName){
        let dataFetched = MainStore.getState().FormsReducer.formData;
        let sectionData = (dataFetched && dataFetched[sectionName])?dataFetched[sectionName].data:null;
        return sectionData
    }

    checkSyntheseCount(){
        let refSection = [
            {"name": "urba", "label": "Document d’urbanisme"},
            {"name": "prescription", "label": "Prescription d’urbanisme"},
            {"name": "risque", "label": "Risques naturels et technologiques"},
            {"name": "servitude", "label": "Servitude d'utilité publique"},
            {"name": "environnement", "label": "Protection environnementale"},
            {"name": "agriculture", "label": "Agriculture"},
            {"name": "taxe", "label": "Taxe"},
        ]
        refSection.map(item=>{
            const countSection = this.getData(item.name)
            item['nb'] = (countSection)?countSection.length:null;
        })
        return refSection
    }
}

export default CUFormService
